import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface CandidateState {
  candidate: {
    name?: any;
    attemptScore: any;
    [key: string]: any;
  };
}

const initialState: CandidateState = {
  candidate: {
    attemptScore: 0,
  },
};

export const candidateSlice = createSlice({
  name: "candidate",
  initialState,
  reducers: {
    updateCurrentCandidate: (
      state,
      action: PayloadAction<Partial<CandidateState["candidate"]>>
    ) => {
      state.candidate = { ...state.candidate, ...action.payload };
    },
    updateCandidateAttemptScore: (state, action: PayloadAction<any>) => {
      state.candidate.attemptScore = {
        ...state.candidate.attemptScore,
        ...action.payload
      };
    },
    resetCandidateScores: (state) => {
      state.candidate.attemptScore = {
        screeningScore: 0,
        screeningTotal: 0,
        interviewScore: 0,
        interviewTotal: 0,
        hpaScore: 0,
        hpaTotal: 0,
      };
    },
  },
});

export const { updateCurrentCandidate, updateCandidateAttemptScore, resetCandidateScores } =
  candidateSlice.actions;

export default candidateSlice.reducer;
